import React, { useState } from "react";
import {
  Spin,
  Form,
  Tabs,
  Col, Row
} from "antd";
import IntlMessages from "../../../util/IntlMessages";
import ds from "../../../Services/DataServices";
import { useHistory } from "react-router-dom";
import { useDispatch, useStore, useSelector } from "react-redux";
import { SALE_TRACKING_SCREEN } from "../../../constants/Pages";
import {
  READ,
  CREATE,
  UPDATE,
  DELETE
} from '../../../constants/RightsAndPermissions'
import {
  loadIsSelectReg,
  loadSelectedOutlet,
  loadSelectedReg,
  setCommonConfigs
} from '../../../appRedux/actions/CommonData'
import {
  checkRightspermissions,
  formatDigits,
  isEmptyObject
} from '../../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import Preparing from './Preparing'
import Serving from './Serving'
import { env } from '../../../env'
import NotAllowedComponent from "../../../components/NotAllowedComponent";
const { REACT_APP_TRACK_REFRESH_TIME } = env

const MINUTE_MS = REACT_APP_TRACK_REFRESH_TIME
  ? parseInt(REACT_APP_TRACK_REFRESH_TIME)
  : 15000
const LogTracking = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { TabPane } = Tabs

  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )

  const [isLoading, setIsLoading] = React.useState(true)
  const [getTableData, setTableData] = React.useState([])
  const [getCurrentTab, setCurrentTab] = useState(1)
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getPreparingAllow, setPreparingAllow] = useState(false)
  const [getServingAllow, setServingAllow] = useState(false)
  const [timeLap, setTimeLap] = useState(1)
  const [getSelectedOutlet, setSelectedOutlet] = React.useState('')
  const [outletName, setOutletName] = React.useState('')
  // const [servingEnable, setServingEnable] = useState(false);

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  React.useEffect(() => {
    dispatch(setCommonConfigs(SALE_TRACKING_SCREEN))
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      let outlet = false
      let reg = false
      if (getReduxSelectedStoreOutlets.id) {
        // setSelectedOutlet(getReduxSelectedStoreOutlets.id);
        // setOutletName(
        //   getReduxSelectedStoreOutlets && getReduxSelectedStoreOutlets.outlet
        //     ? getReduxSelectedStoreOutlets.outlet
        //     : ""
        // );
        outlet = getReduxSelectedStoreOutlets.id
      } else {
        let selectedLocalOut = localStorage.getItem('selectedOut')
        if (selectedLocalOut) {
          selectedLocalOut = JSON.parse(selectedLocalOut)
          // setSelectedOutlet(
          //   getReduxSelectedStoreOutlets.id
          //     ? getReduxSelectedStoreOutlets.id
          //     : selectedLocalOut.id
          // );
          // setOutletName(
          //   selectedLocalOut && selectedLocalOut.outlet
          //     ? getReduxSelectedStoreOutlets.outlet
          //     : ""
          // );
          outlet = getReduxSelectedStoreOutlets.id
            ? getReduxSelectedStoreOutlets.id
            : selectedLocalOut.id
        }
      }

      if (!outlet) {
        dispatch(loadIsSelectReg(true))
      }

      return () => (mounted = false)
      // //;
    }
  }, [getReduxSelectedStoreOutlets])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        // setCurrSymbol(currencyData.currencySymbol);
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    const interval = setInterval(() => {
      setTimeLap(timeLap + 1)
    }, MINUTE_MS)

    return () => clearInterval(interval) // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, [timeLap])

  //for selected outlet
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getReduxSelectedStoreOutlets.id) {
        //outlet
        setSelectedOutlet(getReduxSelectedStoreOutlets.id)
        setOutletName(getReduxSelectedStoreOutlets.outlet)
        dispatch(loadSelectedOutlet(getReduxSelectedStoreOutlets.id))
      } else {
        let selectedLocalOut = localStorage.getItem('selectedOut')
        if (selectedLocalOut) {
          selectedLocalOut = JSON.parse(selectedLocalOut)
          const selOutlet = getReduxSelectedStoreOutlets.id
            ? getReduxSelectedStoreOutlets.id
            : selectedLocalOut.id
          const selOutletName = getReduxSelectedStoreOutlets.outlet
            ? getReduxSelectedStoreOutlets.outlet
            : selectedLocalOut.outlet
          setSelectedOutlet(selOutlet)
          setOutletName(selOutletName)
          dispatch(loadSelectedOutlet(selOutlet))
        }
      }
    }
    return () => (mounted = false)
  }, [getReduxSelectedStoreOutlets])

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }

    //permissions
    if (rpData.servingAllow) {
      setServingAllow(true)
    } else {
      setServingAllow(false)
    }
    if (rpData.preparingAllow) {
      setPreparingAllow(true)
    } else {
      setPreparingAllow(false)
    }
  }

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
    setPreparingAllow(false)
    setServingAllow(false)
  }

  async function getSalesLogs (body) {
    const resp = ds.getSaleLogsService(body, BEHAVIOUR_TYPE.GET)
    await resp
      .then(res => {
        setIsLoading(false)
        if (res && res.tracks && res.tracks.length > 0) {
          setTableData(res.tracks)
        } else {
          setTableData([])
        }
      })
      .catch(e => {
        setTableData([])
        setIsLoading(false)
      })
  }

  function onTabChange (key) {
    if (key == 1) {
      setCurrentTab(key)
    } else if (key == 2) {
      setCurrentTab(key)
    }
  }

  // setInterval(setTimeLap(timeLap + 1, MINUTE_MS));

  return getIsAllowRead ? (
    <div className="Content-wrapper SaleTrackings-pg">
      

<Row>

<Col lg={10} md={10} sm={24} xs={24}>
<h1 className="">Sale Trackings</h1>
</Col>

<Col lg={14} md={14} sm={24} xs={24} className="colors-cont">
<ul className="colors-info">
<li><span className="order-Ready-color"></span> Order Ready</li>
<li><span className="order-Preparing-color"></span> Order Preparing</li>
<li><span className="order-placed-color"></span> Order Placed</li>

<li><span className="order-Cancel-color"></span> Order Cancel</li>
<li><span className="order-Change-color"></span> Order Change</li>
<li><span className="order-Served-color"></span> Order Served</li>
</ul>
</Col>

</Row>


    <Tabs
      defaultActiveKey={!getPreparingAllow && getServingAllow ? 2 : 1}
      size="large"
      onChange={onTabChange}
    >
      {getPreparingAllow && (
        <TabPane tab="Preparing" key={1}>
          <Preparing
            isUpdate={getIsDisableUpdate}
            interval={timeLap}
            outletID={getSelectedOutlet}
            outletName={outletName}
          // servingChange={servingEnable}
          />
        </TabPane>
      )}
      {getServingAllow && (
        <TabPane tab="Serving" key={2}>
          <Serving
            isUpdate={getIsDisableUpdate}
            interval={timeLap}
            outletID={getSelectedOutlet}
            outletName={outletName}
          />
          {/* serveDone={changeForServe} */}
        </TabPane>
      )}
    </Tabs>

    </div>

    
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default LogTracking
